export default __webpack_public_path__ + "static/media/react.bf0d3dcd.jpg";